import React from 'react';

const Divider = () => <div className="border-l" />;

export { Divider };
